export default function isEmptyObject(obj) {
    return (obj !== null) && (typeof obj === 'object') && (Object.keys(obj).length === 0);
}


// WEBPACK FOOTER //
// ./src/components/shared/isEmptyObject.js